export const offeringTypeIcon = {
  mcq: "mcq",
  problem: "coding",
  lecture: "lecture",
  recording: "lecture",
  live: "live",
};
export const OFFERING_ICON_VARIANT = {
  problem: "primary-500",
  mcq: "secondary-500",
  lecture: "teal-500",
  recording: "teal-500",
  live: "danger-400",
};
